import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class TeamsActiveTeamsTableCellUserSelectIndexComponent extends DropdownActivator {
  @service store;
  @tracked people = [];

  get firstPerson() {
    return this.people[0];
  }

  get restCount() {
    return this.people.length - 1;
  }

  get restPeople() {
    return this.people.slice(1).map((person) => person.name);
  }

  get model() {
    return this.args.params?.model;
  }

  get body() {
    return document.body;
  }

  @action
  async loadPeople() {
    const people = await this.model?.people;
    this.people = people;
  }

  @action
  handlePeopleSelect(e) {
    const model = this.model;
    model.people = e;
    model.save();
  }
}
